import i18n from 'modules/core/lib/i18n'

import type { IssuesByKeyFactory, IssuesByKeyParams, SyncIssue } from 'modules/integrations/public'
import { useSyncIssueUrls } from 'modules/integrations/public'

function useEmployeeUpdatesLeaveSyncIssuesByKey({
  integrationName,
  datoId,
  companyId,
}: IssuesByKeyParams): Record<string, SyncIssue> {
  const { integrationSettingsUrl, employeesUrl } = useSyncIssueUrls({ datoId, companyId })

  return {
    missing_employee_code: {
      title: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_employee_code.title',
        { integration_name: integrationName }
      ),
      description: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_employee_code.description',
        { integration_name: integrationName }
      ),
      buttonLabel: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_employee_code.button_label'
      ),
      buttonUrl: employeesUrl,
    },
    missing_legal_entity_code: {
      title: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_legal_entity_code.title',
        { integration_name: integrationName }
      ),
      description: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_legal_entity_code.description',
        { integration_name: integrationName }
      ),
      buttonLabel: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_legal_entity_code.button_label'
      ),
      buttonUrl: integrationSettingsUrl,
    },
    missing_leave_type_code: {
      title: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_leave_type_code.title',
        { integration_name: integrationName }
      ),
      description: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_leave_type_code.description',
        { integration_name: integrationName }
      ),
      buttonLabel: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_leave_type_code.button_label'
      ),
      buttonUrl: integrationSettingsUrl,
    },
    missing_ends_on: {
      title: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_ends_on.title',
        {
          integration_name: integrationName,
        }
      ),
      description: i18n.t(
        'payroll_integrations.employee_update_leave.sync_validations.missing_ends_on.description',
        { integration_name: integrationName }
      ),
    },
  }
}

export const employeeUpdatesLeaveSyncIssuesByKey: IssuesByKeyFactory =
  useEmployeeUpdatesLeaveSyncIssuesByKey
